var $807554f8230db0ed$exports = {};
$807554f8230db0ed$exports = {
  "alpha": "Alfa",
  "black": "\u010Dern\xE1",
  "blue": "Modr\xE1",
  "blue purple": "modrofialov\xE1",
  "brightness": "Jas",
  "brown": "hn\u011Bd\xE1",
  "brown yellow": "hn\u011Bdo\u017Elut\xE1",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "tyrkysov\xE1",
  "cyan blue": "tyrkysovomodr\xE1",
  "dark": "tmav\xE1",
  "gray": "\u0161ed\xE1",
  "grayish": "na\u0161edl\xE1",
  "green": "Zelen\xE1",
  "green cyan": "zelenotyrkysov\xE1",
  "hue": "Odst\xEDn",
  "light": "sv\u011Btl\xE1",
  "lightness": "Sv\u011Btlost",
  "magenta": "purpurov\xE1",
  "magenta pink": "purpurov\u011B r\u016F\u017Eov\xE1",
  "orange": "oran\u017Eov\xE1",
  "orange yellow": "oran\u017Eovo\u017Elut\xE1",
  "pale": "bled\xE1",
  "pink": "r\u016F\u017Eov\xE1",
  "pink red": "r\u016F\u017Eovo\u010Derven\xE1",
  "purple": "fialov\xE1",
  "purple magenta": "fialov\u011B purpurov\xE1",
  "red": "\u010Cerven\xE1",
  "red orange": "\u010Dervenooran\u017Eov\xE1",
  "saturation": "Sytost",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " pr\u016Fhledn\xE9");
  },
  "very dark": "velmi tmav\xE1",
  "very light": "velmi sv\u011Btl\xE1",
  "vibrant": "z\xE1\u0159iv\xE1",
  "white": "b\xEDl\xE1",
  "yellow": "\u017Elut\xE1",
  "yellow green": "\u017Elutozelen\xE1"
};
export { $807554f8230db0ed$exports as default };